<template>
  <div v-if="this.$store.state.comicData">
    <div v-if="this.$store.state.comicData.comic.is_locked">
      <h4 class="comic-locked">Time's up! You can no longer vote or comment on this comic.<br> (Comic closed {{timer}})</h4>
    </div>
    <div v-if="!this.$store.state.comicData.comic.is_locked && ! this.$store.state.user">
      <h4 class="not-logged-in">
        You must login to vote, comment, ask questions, and suggest what should happen next!
        <br><br>
        <router-link class="button" to="/login">Login</router-link>
      </h4>
    </div>
    <div v-if="!this.$store.state.comicData.comic.is_locked && this.$store.state.user">
      <div class="row closing-time">
        <p>The comment time for this comic closes {{timer}} ({{totalTime}})</p>
      </div>
      <div
        v-bind:class="{
          'row': true,
          'comic-post' : true,
          'comic-post--new' : true,
        }"
      >
        <div v-if="newPostError">
          <p>{{newPostError}}</p>
        </div>
        <div class="twelve columns">
          <div class="comic-post-cell comic-post-cell--username comic-post-cell--username--new">
            {{this.$store.state.user.username}}
          </div>
        </div>
        <div class="twelve columns">
          <div class="comic-post-cell comic-post-cell--text comic-post-cell--text--new">
            <textarea
              id="new-post-text"
              class="input u-full-width comic-post-cell--text--new__input"
              placeholder="What do you think?"
              v-model="newPostText"
            ></textarea>
          </div>
        </div>
        <div class="twelve columns">
          <div class="comic-post-cell comic-post-cell--type--new">
            <label> What kind of post is this?
              <select
                id="new-post-type"
                class="comic-post-cell--type"
                v-model="newPostType"
              >
                <option
                  value="suggestion"
                  selected="selected"
                  v-if="!userHasSuggestion"
                >Suggest that this should happen next</option>
                <option value="question">Ask the author this as a question</option>
                <option value="comment">Just post this as a general comment</option>
              </select>
            </label>
          </div>
        </div>
        <div class="twelve columns">
          <div class="comic-post-cell comic-post-cell--submit">
            <button
              class="comic-post-cell--submit__button button"
              @click="sendPost"
            >Go!</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.$store.state.comicData.comic.is_locked && !this.$store.state.user">
      <h3>
        <router-link
          to="/login"
          class="button new-post-login"
        >Login</router-link> to leave a post or upvote one!
      </h3>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
let intervalHandle = null

export default {
  props: ['userHasSuggestion'],
  data () {
    return {
      newPostText: '',
      newPostType: this.userHasSuggestion ? 'comment' : 'suggestion',
      newPostError: '',
      timer: '',
      totalTime: ''
    }
  },
  created () {
    this.updateTimer()
    intervalHandle = window.setInterval(this.updateTimer.bind(this), 10 * 1000)
  },
  destroyed () {
    window.clearInterval(intervalHandle)
  },
  methods: {
    sendPost () {
      this.$store.dispatch('createPost', {
        text: this.newPostText,
        type: this.newPostType,
        comicId: this.$store.state.comicData.comic.pk_comic_id
      }).then(
        (message) => {
          this.newPostText = ''
          this.newPostType = 'comment'
          this.newPostError = 'Your comment has been successfully added!'
        },
        (err) => {
          this.newPostError = err
        }
      )
    },
    updateTimer () {
      if (!this.$store.state.comicData.comic) {
        return
      }
      const lockTime = moment(this.$store.state.comicData.comic.lock_time)
      if (lockTime.isBefore(moment())) {
        this.$store.commit('lockComic', {})
        this.timer = lockTime.format('MMMM Do YYYY, h:mm:ss a')
        this.totalTime = ''
        window.clearInterval(intervalHandle)
      } else {
        this.timer = lockTime.fromNow()
        this.totalTime = lockTime.format('MMMM Do YYYY, h:mm:ss a')
      }
    }
  }
}
</script>

<style scoped>
.comic-locked {
  font-size: 1.8rem;
  text-align: center;
  margin: 1.8rem auto;
  padding: 1.8rem;
  background-color: #B61D31;
  color: #ccc;
}

.not-logged-in {
  font-size: 1.8rem;
  text-align: center;
  margin: 1.8rem auto;
  padding: 1.8rem;
}

.closing-time p {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// NewPost.vue?19d7dc08